<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12">
                <v-tabs v-model="selectedOffice" align-tabs="start" color="darkGreen" @update:modelValue="initPrograms()">
                    <v-tab :class="{'font-weight-black': selectedOffice == institute.id}" v-for="institute in instituteData" :key="institute.id" :value="institute.id">
                        {{ institute.abbrev }}
                    </v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-select
                    v-model="selectedProgram"
                    @update:model-value="initUsers()"
                    variant="outlined"
                    label="Program"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                    :items="programData"
                    item-title="abbrev"
                    item-value="id"
                ></v-select>
            </v-col>
            <v-col class="text-right" cols="12" md="4">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Faculty Course Load
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.name="{ item }">
                                <span>{{ item.fname }} {{ item.mname ? item.mname[0] + '.' : '' }} {{ item.lname }}{{ item.suffix ? ', ' + item.suffix : '' }}</span>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="d-flex justify-end ga-2">
                                    <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="View" color="green" elevation="3"></v-btn>
                                </div>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <DirectorFacultyCourseLoadingDialog ref="DirectorFacultyCourseLoadingDialog" @refresh="initUsers()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import DirectorFacultyCourseLoadingDialog from '../Dialogs/DirectorFacultyCourseLoadingDialog.vue';

export default defineComponent({
    components: {
        DirectorFacultyCourseLoadingDialog
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'name' },
                { title: 'Academic Rank', align: 'start', sortable: true, key: 'academicRank.description' },
                { title: 'Employment Status', align: 'start', sortable: true, key: 'employmentStatus.description' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            instituteData: [],
            programData: [],
            selectedOffice: null,
            selectedProgram: null,
        }
    },
    methods: {
        async init(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllInstituteAndExternalCampus')
            .then(res => {
                this.instituteData = res.data
                this.selectedOffice = this.instituteData[0].id
            });

            this.initPrograms()
        },
        async initPrograms(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/programs/findAllProgramByInstitute/' + this.selectedOffice)
            .then(res => {
                this.programData = res.data
                this.selectedProgram = this.programData[0].id
            });

            this.initUsers()
        },
        async initUsers(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findFacultyWithLoadByProgram/' + this.selectedProgram + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddDialog(){
            this.$refs.DirectorFacultyCourseLoadingDialog.initAdd(this.selectedProgram)
        },
        showEditDialog(data){
            this.$refs.DirectorFacultyCourseLoadingDialog.initUpdate(data)
        }
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>